// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__YDwTj","user":"navbar_user__Yo6Nd","logo":"navbar_logo__511ak"};